<h2 class="titulo" mat-dialog-title>
  <span>{{ 'ROUTE_REPORT.PRINTING.SUMMARY_PLANNED_CARRIED_OUT' | translate | titlecase }}</span>
  <button class="not-print" mat-dialog-close mat-icon-button>
    <mat-icon fontSet="material-icons-outlined">close</mat-icon>
  </button>
</h2>

<mat-dialog-content #resumoDiv class="outer-container">
  <table class="dialog-table">
    <tr>
      <td class="dialog-table-header-1" colspan="7">
        {{ 'ROUTE_REPORT.PRINTING.MONITORING_SUMMARY' | translate | titlecase }}
      </td>
    </tr>

    <tr>
      <td class="bold separated" colspan="2"> {{ 'ROUTE_REPORT.PRINTING.VEHICLE' | translate }} </td>
      <td colspan="5"> {{resumo.placa}} </td>
    </tr>
    <tr>
      <td class="bold separated" colspan="2"> {{ 'ROUTE_REPORT.PRINTING.DRIVER' | translate }} </td>
      <td colspan="5"> {{resumo.motorista}} </td>
    </tr>
    <tr>
      <td class="bold separated" colspan="2"> {{ 'ROUTE_REPORT.PRINTING.VALUE' | translate }} </td>
      <td colspan="5"> {{(resumo.planejado.valor | currency) ?? '-'}} </td>
    </tr>

    <ng-container *ngFor="let visitas of dadosVisitas">
      <tr>
        <td class="dialog-table-header-2" colspan="7">
          <span *ngIf="visitas.tipo === 'Planejado'">{{ 'ROUTE_REPORT.PRINTING.PLANNED_SUMMARY' | translate }}</span>
          <span *ngIf="visitas.tipo === 'Executado'">{{ 'ROUTE_REPORT.PRINTING.CARRIED_OUT_SUMMARY' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="bold separated" colspan="2">
          <span *ngIf="visitas.tipo === 'Planejado'">{{ 'ROUTE_REPORT.PRINTING.PLANNED_KILOMETERS' | translate }}</span>
          <span *ngIf="visitas.tipo === 'Executado'">{{ 'ROUTE_REPORT.PRINTING.CARRIED_OUT_KILOMETERS' | translate }}</span>
        </td>
        <td colspan="5"> {{visitas.distancia | number}} {{ 'ROUTE_REPORT.PRINTING.KILOMETERS' | translate }} </td>
      </tr>
      <tr>
        <td class="bold separated" colspan="2">
          <span *ngIf="visitas.tipo === 'Planejado'">{{ 'ROUTE_REPORT.PRINTING.PLANNED_TIME' | translate }}</span>
          <span *ngIf="visitas.tipo === 'Executado'">{{ 'ROUTE_REPORT.PRINTING.CARRIED_OUT_TIME' | translate }}</span>
        </td>
        <td colspan="5"> {{visitas.tempo}} {{ 'ROUTE_REPORT.PRINTING.HOURS' | translate }} </td>
      </tr>
      <tr>
        <td class="bold separated"> {{ 'ROUTE_REPORT.PRINTING.NUMBER' | translate }} </td>
        <td class="bold separated"> {{ 'ROUTE_REPORT.PRINTING.CODE' | translate }} </td>
        <td class="bold separated"> {{ 'ROUTE_REPORT.PRINTING.CLIENT_CODE' | translate }} </td>
        <td class="bold separated"> {{ 'ROUTE_REPORT.PRINTING.CORPORATE_NAME' | translate }} </td>
        <td class="bold separated"> {{ 'ROUTE_REPORT.PRINTING.STATUS' | translate }} </td>
        <td class="bold separated"> {{ 'ROUTE_REPORT.PRINTING.ARRIVAL' | translate }} </td>
        <td class="bold separated"> {{ 'ROUTE_REPORT.PRINTING.DEPARTURE' | translate }} </td>
      </tr>
      <tr *ngFor="let pedido of visitas.lista">
        <td class="separated"> {{ pedido.ordem === 0 ?"-" :pedido.ordem }} </td>
        <td class="separated"> {{pedido.codigo}} </td>
        <td class="separated"> {{pedido.codigoCliente | cpfcnpj}} </td>
        <td class="separated"> {{pedido.razaoSocial ?? '-'}} </td>
        <td class="separated"> {{'ROUTE_HISTORY.TERMS.' + pedido.status | translate}} <span *ngIf="pedido.incidente && visitas.tipo === 'Executado'"> - {{pedido.incidente}}</span></td>
        <td class="separated"> {{prioridade(pedido.horaChegada, visitas.tipo)}} </td>
        <td class="separated"> {{prioridade(pedido.horaSaida, visitas.tipo)}} </td>
      </tr>

    </ng-container>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end" class="not-print">
  <button (click)="print()" mat-icon-button matTooltip="Imprimir" matTooltipPosition="above" style="display: none">
    <mat-icon fontSet="material-icons-outlined">print</mat-icon>
  </button>
  <button (click)="baixarXls()" mat-flat-button color="primary" matTooltip="Baixar XLS" matTooltipPosition="above">
    <mat-icon fontSet="material-icons-outlined">get_app</mat-icon> XLS
  </button>
</mat-dialog-actions>
